<template>
  <div class="main-image-gen">
    <div class="mig-toolbar">
      <button class="scg-back-btn" @click="$emit('back')">
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="16" height="16">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
        返回裂变图
      </button>
      <span class="scg-mode-tag">主图生成 (白底)</span>
      <button class="scg-generate-all-btn" @click="workbench.generateAllMainImages" :disabled="workbench.mainImageGen.loading">
        {{ workbench.mainImageGen.loading ? '生成中...' : '全部生成' }}
      </button>
    </div>

    <div v-for="(product, pi) in activeProducts" :key="product.id" class="mig-product-section">
      <div class="mig-product-header">
        <span class="mig-product-name">{{ product.name }}</span>
        <button
          class="mig-download-zip-btn"
          :disabled="!hasAnyImage(pi)"
          @click="downloadZip(pi)"
        >下载全部图片</button>
      </div>

      <div class="mig-colors">
        <!-- Promo images -->
        <div v-for="sel in getPromoSlotsForProduct(pi)" :key="'p-' + sel.pi + '-' + sel.si" class="mig-color-row">
          <div class="mig-color-label">宣传图 {{ sel.si + 1 }}</div>
          <div class="mig-color-content">
            <div class="mig-source-area">
              <span class="mig-source-tag">原图</span>
              <div class="mig-source-img" v-if="workbench.getSelectedPromoImageForMain(sel.pi, sel.si)">
                <img :src="workbench.getSelectedPromoImageForMain(sel.pi, sel.si)" />
              </div>
            </div>
            <div class="mig-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
            <div class="mig-result-area">
              <span class="mig-source-tag">白底主图</span>
              <div class="mig-result-slot" v-if="getResult(getPromoKey(sel.pi, sel.si))">
                <template v-if="getResult(getPromoKey(sel.pi, sel.si)).loading">
                  <div class="scg-loading-ring">
                    <svg viewBox="0 0 36 36">
                      <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                      <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#165dff" stroke-width="3"
                        :stroke-dasharray="100" :stroke-dashoffset="100 - getResult(getPromoKey(sel.pi, sel.si)).progress" stroke-linecap="round"
                        transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="ring-text">{{ Math.round(getResult(getPromoKey(sel.pi, sel.si)).progress) }}%</span>
                  </div>
                </template>
                <template v-else-if="getResult(getPromoKey(sel.pi, sel.si)).url">
                  <img :src="getResult(getPromoKey(sel.pi, sel.si)).url" class="mig-result-img" @click="openMainLightbox(getResult(getPromoKey(sel.pi, sel.si)).url)" />
                  <div class="mig-result-actions">
                    <button class="scg-action-btn" title="裁剪" @click.stop="startMainCrop(getPromoKey(sel.pi, sel.si))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
                        <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="重新生成" @click="genPromo(sel.pi, sel.si)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="下载" @click="downloadImage(getResult(getPromoKey(sel.pi, sel.si)).url, `main-promo-${sel.pi}-${sel.si}.png`)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn delete" title="删除" @click="workbench.clearMainImageResult(getPromoKey(sel.pi, sel.si))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                </template>
                <template v-else-if="getResult(getPromoKey(sel.pi, sel.si)).error">
                  <div class="mig-error">{{ getResult(getPromoKey(sel.pi, sel.si)).error }}</div>
                </template>
              </div>
              <div class="mig-result-empty" v-else>
                <button class="mig-gen-btn" @click="genPromo(sel.pi, sel.si)">生成</button>
              </div>
            </div>
          </div>
        </div>

        <!-- Fission images -->
        <div v-for="(color, ci) in (workbench.imageGen.fissionColors[pi] || [])" :key="color.id" class="mig-color-row">
          <div class="mig-color-label">{{ color.label }}</div>
          <div class="mig-color-content">
            <div class="mig-source-area">
              <span class="mig-source-tag">原图</span>
              <div class="mig-source-img" v-if="workbench.getSelectedFissionImageForColor(pi, ci)">
                <img :src="workbench.getSelectedFissionImageForColor(pi, ci)" />
              </div>
              <div class="mig-source-empty" v-else>未选择</div>
            </div>
            <div class="mig-arrow">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="20" height="20">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </div>
            <div class="mig-result-area">
              <span class="mig-source-tag">白底主图</span>
              <div class="mig-result-slot" v-if="getResult(getFissionKey(pi, ci))">
                <template v-if="getResult(getFissionKey(pi, ci)).loading">
                  <div class="scg-loading-ring">
                    <svg viewBox="0 0 36 36">
                      <circle class="ring-bg" cx="18" cy="18" r="16" fill="none" stroke="#e5e6eb" stroke-width="3"/>
                      <circle class="ring-fg" cx="18" cy="18" r="16" fill="none" stroke="#165dff" stroke-width="3"
                        :stroke-dasharray="100" :stroke-dashoffset="100 - getResult(getFissionKey(pi, ci)).progress" stroke-linecap="round"
                        transform="rotate(-90 18 18)"/>
                    </svg>
                    <span class="ring-text">{{ Math.round(getResult(getFissionKey(pi, ci)).progress) }}%</span>
                  </div>
                </template>
                <template v-else-if="getResult(getFissionKey(pi, ci)).url">
                  <img :src="getResult(getFissionKey(pi, ci)).url" class="mig-result-img" @click="openMainLightbox(getResult(getFissionKey(pi, ci)).url)" />
                  <div class="mig-result-actions">
                    <button class="scg-action-btn" title="裁剪" @click.stop="startMainCrop(getFissionKey(pi, ci))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"/>
                        <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="重新生成" @click="genFission(pi, ci)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="23 4 23 10 17 10"/>
                        <path d="M20.49 15a9 9 0 1 1-2.12-9.36L23 10"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn" title="下载" @click="downloadImage(getResult(getFissionKey(pi, ci)).url, `main-${workbench.products[pi]?.name}-${color.label}.png`)">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
                        <polyline points="7 10 12 15 17 10"/>
                        <line x1="12" y1="15" x2="12" y2="3"/>
                      </svg>
                    </button>
                    <button class="scg-action-btn delete" title="删除" @click="workbench.clearMainImageResult(getFissionKey(pi, ci))">
                      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="14" height="14">
                        <polyline points="3 6 5 6 21 6"/>
                        <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/>
                      </svg>
                    </button>
                  </div>
                </template>
                <template v-else-if="getResult(getFissionKey(pi, ci)).error">
                  <div class="mig-error">{{ getResult(getFissionKey(pi, ci)).error }}</div>
                </template>
              </div>
              <div class="mig-result-empty" v-else>
                <button class="mig-gen-btn" @click="genFission(pi, ci)" :disabled="!workbench.getSelectedFissionImageForColor(pi, ci)">
                  {{ workbench.getSelectedFissionImageForColor(pi, ci) ? '生成' : '未选图' }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ImageCropper
      :visible="cropState.visible"
      :imageSrc="cropState.imageSrc"
      @confirm="onCropConfirm"
      @cancel="onCropCancel"
      @restore="onCropRestore"
    />
  </div>
</template>

<script setup>
import { computed, reactive, ref } from 'vue'
import { useWorkbenchStore } from '@/stores/useWorkbenchStore'
import ImageCropper from '@/components/common/ImageCropper.vue'

const workbench = useWorkbenchStore()

// eslint-disable-next-line no-undef
defineEmits(['back'])

const activeProducts = computed(() => {
  const promoPis = [...new Set(workbench.selectedPromoForMain.map(s => s.pi))]
  const fissionPis = [...new Set(workbench.selectedFissionImages.map(s => s.pi))]
  const allPis = [...new Set([...promoPis, ...fissionPis])]
  return allPis.map(i => workbench.products[i]).filter(Boolean)
})

const getPromoSlotsForProduct = (pi) => workbench.selectedPromoForMain.filter(s => s.pi === pi)

const getPromoKey = (pi, si) => workbench.getMainImageKeyPromo(pi, si)
const getFissionKey = (pi, ci) => workbench.getMainImageKey(pi, ci)

const getResult = (key) => workbench.mainImageGen.results[key] || null

const genPromo = (pi, si) => {
  const url = workbench.getSelectedPromoImageForMain(pi, si)
  if (url) workbench.generateOneMainImage(getPromoKey(pi, si), url)
}

const genFission = (pi, ci) => {
  const url = workbench.getSelectedFissionImageForColor(pi, ci)
  if (url) workbench.generateOneMainImage(getFissionKey(pi, ci), url)
}

const openMainLightbox = (url) => {
  const urls = Object.values(workbench.mainImageGen.results).filter(r => r.url).map(r => r.url)
  workbench.openLightbox(url, urls)
}

const downloadImage = (url, filename) => {
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
}

const hasAnyImage = (pi) => workbench.getProductAllImageUrls(pi).length > 0

const downloadingPi = ref(-1)
const downloadZip = async (pi) => {
  downloadingPi.value = pi
  try {
    await workbench.downloadProductZip(pi)
  } catch (e) {
    alert('下载失败: ' + e.message)
  } finally {
    downloadingPi.value = -1
  }
}

const cropState = reactive({ visible: false, imageSrc: '', key: '' })

const startMainCrop = (key) => {
  const slot = getResult(key)
  if (!slot?.url) return
  cropState.imageSrc = slot.url
  cropState.key = key
  cropState.visible = true
}

const onCropConfirm = (croppedBase64) => {
  workbench.applyCropResult('main', -1, cropState.key, croppedBase64)
  cropState.visible = false
}

const onCropRestore = () => {
  workbench.restoreOriginalImage('main', -1, cropState.key)
  cropState.visible = false
}

const onCropCancel = () => {
  cropState.visible = false
}
</script>

<style scoped>
.mig-download-zip-btn {
  padding: 6px 16px;
  background: #0fc6c2;
  color: #fff;
  border: none;
  border-radius: 6px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.2s;
}
.mig-download-zip-btn:hover:not(:disabled) {
  background: #0ba5a1;
}
.mig-download-zip-btn:disabled {
  background: #c9cdd4;
  cursor: not-allowed;
}
</style>
